import React, { useState, useEffect } from 'react';
import { supabase } from '../integrations/supabase/client';

export const TestVideoUpdate: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);

  const handleUpdate = async () => {
    setLoading(true);
    try {
      console.log('🎬 Chamando edge function para atualizar vídeo padrão...');
      
      const { data, error } = await supabase.functions.invoke('update-default-video', {
        body: {}
      });

      if (error) {
        console.error('❌ Erro ao chamar função:', error);
        throw error;
      }

      console.log('✅ Função executada com sucesso:', data);
      setResult(data);
    } catch (error) {
      console.error('❌ Erro ao atualizar vídeo padrão:', error);
      setResult({ error: error instanceof Error ? error.message : String(error) });
    } finally {
      setLoading(false);
    }
  };

  // Auto-execute on mount
  useEffect(() => {
    handleUpdate();
  }, []);

  return (
    <div className="p-4 border rounded">
      <h3 className="font-bold mb-2">Atualizar Vídeo Padrão em Todos os Imóveis</h3>
      <button 
        onClick={handleUpdate}
        disabled={loading}
        className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
      >
        {loading ? 'Atualizando...' : 'Atualizar Vídeos'}
      </button>
      
      {result && (
        <div className="mt-4 p-2 bg-gray-100 rounded">
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};